export default __webpack_public_path__ + "static/media/home4.978bf002.jpg";